import React from 'react';
import { Card, Typography } from 'antd';
import { TagsOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import HashtagManagement from './admin/HashtagManagement';
import './AdminPanel.css';

const { Title } = Typography;

const AdminHashtags = () => {
  return (
    <AppLayout activeMenu="/admin/hashtags">
      <Card className="admin-content-card">
        <div className="admin-content-header">
          <Title level={3} style={{ margin: 0 }}>
            <TagsOutlined style={{ marginRight: 12, color: '#14B8A6' }} />
            Hashtag Management
          </Title>
          <p style={{ margin: '8px 0 0 0', color: '#666' }}>
            Manage hashtags for content scraping and tracking
          </p>
        </div>
        <HashtagManagement embedded />
      </Card>
    </AppLayout>
  );
};

export default AdminHashtags;
